


export const OdooConfig = async () => {



  /* const configcolpruebas = {
    host: 'https://0462-2800-e6-4001-feee-39d8-cb9f-d869-9cff.ngrok-free.app',
    port: '8071',
    database: 'bcan2',
    encryptKey: 'zEA2tiTWsWABVz7El8OBxfLN7K5X1Qni'
  } */

  // const configcolpruebas = {
  //   host: 'https://dydcliente.dydasesorias.com.co/',
  //   port: '',
  //   database: 'gymartpruebas',
  //   encryptKey: 'zEA2tiTWsWABVz7El8OBxfLN7K5X1Qni'
  // }
  // return configcolpruebas;

  const configcolprod = {
    host: 'https://gymartadmin.reactiva.com.co',
    port: '',
    database: 'gymartadmin',
    encryptKey: 'zEA2tiTWsWABVz7El8OBxfLN7K5X1Qni'
  }
  return configcolprod;
}

export const version = '1.0'
export const clientSession = { user: 'cristian', password: '1111' }
export const country = 'colombiapruebas'; 
